import { X } from "lucide-react";
import { Link } from "react-router-dom";

export const Logo = ({ size = 28 }) => <img src="/logo.png" alt="Triggerific-Pilot" style={{ width: size, height: size }} className="object-contain" />;

export function BrandHeader({ size = 28, right, light = false }) {
  return (
    <div className="flex items-center justify-between" data-testid="brand-header">
      <Link to="/" className="flex items-center gap-2.5">
        <Logo size={size} />
        <span className={`font-bold text-[19px] tracking-[0.2px] ${light ? "text-white" : "text-t-on"}`}>Triggerific-Pilot</span>
      </Link>
      {right}
    </div>
  );
}

export function CloseBtn({ onClick, testId }) {
  return (
    <button onClick={onClick} data-testid={testId} aria-label="Close"
      className="w-10 h-10 rounded-full grid place-items-center bg-t-surface2 text-t-on2 hover:bg-t-surface3 transition-colors">
      <X size={20} strokeWidth={2.5} />
    </button>
  );
}

export function Page({ children, className = "" }) {
  return <div className={`mx-auto w-full max-w-2xl px-5 sm:px-8 pt-[max(1.5rem,env(safe-area-inset-top))] pb-[calc(7rem+env(safe-area-inset-bottom))] md:pb-16 ${className}`}>{children}</div>;
}

export function Spinner({ className = "" }) {
  return <span className={`inline-block w-5 h-5 rounded-full border-2 border-current border-t-transparent tf-spin ${className}`} />;
}
